import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  ImageField,
  StringField,
  LinkField,
  VideoSitecoreField,
  TField,
  TStringField,
  THeadingTag,
  TImageField,
} from '../../../types/types';
import { WithSitecoreContextProps } from '@sitecore-jss/sitecore-jss-react/types/enhancers/withSitecoreContext';
import { SplitModuleProps } from '../../splitModule/types/splitModule.types';

export enum ColumnLayoutEnum {
  TwoColumnLayout = '2ColumnLayout',
  ThreeColumnLayout = '3ColumnLayout',
  FourColumnLayout = '4ColumnLayout',
}

export type TColumnLayout = {
  name: string;
  fields: {
    Key: {
      value: string | ColumnLayoutEnum;
    };
  };
};
export type TCardProps = {
  id?: string;
  cardIndex: number;
  card: TCard;
  layout: string | ColumnLayoutEnum;
  isEE: boolean;
  triangle?: StringField;
  cardHeadingTag?: THeadingTag;
};

export type TIconProps = {
  fields?: {
    iconKey?: TStringField;
  };
};

export type TCard = {
  cardCtaTextLink?: LinkField;
  cardSubheading?: StringField;
  cardHeading?: StringField;
  cardCtaButton?: LinkField;
  image?: ImageField;
  mobileImage?: ImageField;
  icon?: TIconProps;
  video?: VideoSitecoreField;
  useVideo?: TField<boolean>;
  items: Array<TSplitModulePopup>;
};

export type TSplitModulePopup = {
  fields: {
    popUpLabel: {
      value: string;
    };
    items: Array<SplitModuleProps>;
  };
};

export type TCardFields = {
  fields: TCard;
  id?: string;
  dataSource?: string;
};

export type TCardColumnLayoutFields = {
  sectionEyebrow?: StringField;
  sectionHeading?: StringField;
  sectionSubheading?: StringField;
  sectionCtaTextLink?: LinkField;
  columnLayout?: TColumnLayout;
  items?: TCardFields[];
  uiWhiteTriangle?: StringField;
  isComponentUnreleased?: boolean;
};

export type TCardColumnLayoutParams = {
  backgroundColor?: string;
  headingTag?: string;
};
export type TCardColumnLayoutProps = WithSitecoreContextProps & {
  fields?: TCardColumnLayoutFields;
  rendering?: ComponentRendering;
  params?: TCardColumnLayoutParams;
};

export type TCardImage = {
  imageOrThumbnail?: TImageField;
  mobileImageOrThumbnail?: TImageField;
  isEE?: boolean;
  useVideo?: boolean;
  showOverlayVideo: () => void;
  id?: string;
  layout: string | ColumnLayoutEnum;
  isWide: boolean;
  triangle?: StringField;
};

export type TCardText = {
  title?: TStringField;
  subheading?: TStringField;
  cardHeadingTag?: THeadingTag;
};

export type TCardButtons = {
  isEE: boolean;
  cta1?: LinkField;
  cta2?: LinkField;
  title?: TStringField;
  cardIndex: number;
  isWide: boolean;
  handleSplitModuleModal: (state: boolean) => void;
  showPopupWithSplitModule: boolean;
  splitModuleLabel: string;
};
